"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = require("../Button/Button");
var _HeaderModule = _interopRequireDefault(require("./Header.module.css"));
var _logo = _interopRequireDefault(require("../assets/icons/logo.svg"));
var _smallLogo = _interopRequireDefault(require("../assets/icons/small-logo.svg"));
var _components = require("../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Header = function Header(_ref) {
  var user = _ref.user,
    onLogin = _ref.onLogin,
    onLogout = _ref.onLogout,
    onCreateAccount = _ref.onCreateAccount,
    logo = _ref.logo;
  var dimension = (0, _components.useDimension)();
  var size = dimension.size;
  return /*#__PURE__*/_react.default.createElement(_components.DimensionContext.Provider, {
    value: dimension
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      borderBottom: '1px solid #2e3037'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    fluid: 'gigantic'
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: _HeaderModule.default.header
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    className: _HeaderModule.default.logo
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: ['chitovic', 'sm', 'md', 'lg'].indexOf(size) > -1 ? _smallLogo.default : _logo.default,
    alt: 'logo',
    width: '100%'
  })), /*#__PURE__*/_react.default.createElement("section", {
    className: _HeaderModule.default.promo
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    className: _HeaderModule.default.local
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "https://www.lider-bet.com/gui/web/images/home20.png",
    alt: 'promo'
  })), /*#__PURE__*/_react.default.createElement("a", {
    href: "#"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _HeaderModule.default.market
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAABHNCSVQICAgIfAhkiAAAAZ9JREFUOE+lVMtRwzAU3FUKwIQCoAOgAsgAZ+iAdABUQKgA04GpAOcMmYQO0gGhABinAGuZJ9tJ/GGA4R2l0Wp/EvGP0cvOBagjABcBxvlD/gVP0yhC3jsPANQxwKh23ucD6qWfAXiD/A3PslnzAk2jA+TOWAxBHrQJ6B3gbrGuO2rSH0G4BrkFIYXLk2LPmQxjsdcCEcagZnA+5SBbaLJjRI4APQTJhRQXg7zstEBaAkgBpujlMw4yU7WaQAq8BfBa81DTaA+5mxdstQSRwPmEg2zedVEg4t0VgOvCT2WtUFb0hTFPP4r0GqPn6BjOXQIc1rdKyZ30pTlPPw+rvXXCMr/X4VR29PzI/GwzDN3CU9GrfBtAJWtYr0lIdwSXWzArT9uA5qPvvZU1yFpdkx4hn1QVk2RdtG7ajDuLrUl/se6W1SAEFJcBLWoWSekG4ON3gDFAS+8VQMKTj6KbXQFJ2lhup7wZgnkj2RPDffASeCAZ/5lh44B1cL9cy0haUKspPazqlf74Oaju0ZJsfAgNG34DaJJNpkmOm5Kbtn4BG5bEj50PP7cAAAAASUVORK5CYII=",
    alt: 'market',
    className: _HeaderModule.default.icon
  }), /*#__PURE__*/_react.default.createElement("span", null, "\u10DB\u10D0\u10E0\u10D9\u10D4\u10E2\u10D8"))), /*#__PURE__*/_react.default.createElement("a", {
    href: "#"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _HeaderModule.default.news
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAMAAADDGrRQAAABBVBMVEX/40b/////40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40b/40Z1AsWIAAAAVnRSTlMAAAIEBQYNDxMYGRoeIyUqKy0vNTg/QEFDRkhJSktNVFhaXmFna25vcXl7fH6AgoOIiYyOj5GUl5iboq2vsLO0tbjAw8nP0dne3+Hj5OXm6evu7/T8/jvh+I8AAAC6SURBVHgBTc7XUoYwFEXhbIv+9iJ2wI5iQVHsvYtd0fX+jyIJXmRdfmfOzDbyGr36jiV5Nn4DvPgWPcBB1zYtZyOTE1H2Dpvd9YU5ayfYvlbdRw87tW1QhOHUoP5jdz01PMrvt8gxnMnv52gF80Snb+THH2aM8vTidn+6oXb2ZoeNMqCCct7aEKndEsCnWklFlXRogcBaH7AmaekNli9ps6ZnoF918T2cy9k1kMg1s9Xb2OLr3eGAvP4AJG4h3x0EUj4AAAAASUVORK5CYII=",
    alt: 'news',
    className: _HeaderModule.default.icon
  }), /*#__PURE__*/_react.default.createElement("span", null, "\u10D0\u10E5\u10EA\u10D8\u10D4\u10D1\u10D8")))), /*#__PURE__*/_react.default.createElement("div", {
    className: _HeaderModule.default.right
  }, user.isLogged ? /*#__PURE__*/_react.default.createElement(_Button.Button, null, "\u10D2\u10D0\u10E1\u10D5\u10DA\u10D0") : /*#__PURE__*/_react.default.createElement("section", {
    className: _HeaderModule.default.login
  }, /*#__PURE__*/_react.default.createElement(_components.DimensionWrapper, {
    hidden: ['gigantic']
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: onLogin,
    variant: "secondary",
    className: (0, _classnames.default)(_HeaderModule.default.btn, _HeaderModule.default.auth)
  }, "\u10E8\u10D4\u10E1\u10D5\u10DA\u10D0")), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "success",
    onClick: onCreateAccount,
    className: _HeaderModule.default.btn
  }, ['chitovic', 'md'].indexOf(size) > -1 ? /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faUserPlus
  }) : 'რეგისტრაცია'), /*#__PURE__*/_react.default.createElement(_components.DimensionWrapper, {
    hidden: ['sm', 'md', 'lg', 'xl', 'xxl']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _HeaderModule.default.inputContainer,
    style: {
      backgroundImage: 'url("https://www.lider-bet.com/gui/web/css/2019/img/u_2019.png")'
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "username",
    placeholder: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
  }), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "secondary"
  }, "\u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D0")), /*#__PURE__*/_react.default.createElement("div", {
    className: _HeaderModule.default.inputContainer,
    style: {
      backgroundImage: 'url("https://www.lider-bet.com/gui/web/css/2019/img/p_2019.png")'
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "password",
    placeholder: "\u10DE\u10D0\u10E0\u10DD\u10DA\u10D8"
  }), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "secondary"
  }, "\u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D0")), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: onLogin,
    variant: "secondary",
    className: _HeaderModule.default.btn
  }, "\u10E8\u10D4\u10E1\u10D5\u10DA\u10D0")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown, {
    className: _HeaderModule.default.dropdown
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Toggle, {
    variant: "outline-dark",
    id: "dropdown-basic"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "https://www.lider-bet.com/gui/web/css/2019/img/ka_flag.png",
    alt: "Ka Flag"
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Menu, {
    className: _HeaderModule.default.menu,
    variant: "dark"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    href: "#",
    className: _HeaderModule.default.item
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "https://www.lider-bet.com/gui/web/css/2019/img/ru_flag.png",
    alt: "Ru Flag"
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    href: "#",
    className: _HeaderModule.default.item
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "https://www.lider-bet.com/gui/web/css/2019/img/en_flag.png",
    alt: "En Flag"
  }))))))))));
};
exports.Header = Header;
Header.propTypes = {
  user: _propTypes.default.shape({}),
  onLogin: _propTypes.default.func.isRequired,
  onLogout: _propTypes.default.func.isRequired,
  onCreateAccount: _propTypes.default.func.isRequired
};
Header.defaultProps = {
  user: null
};